<template>
	<div class="FolderIcon3 svgIcon" :style="{ width: size + 'px', height: size + 'px' }">
		<svg t="1691985932648" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21177" :width="size" :height="size">
			<path d="M832 896H192c-70.4 0-128-57.6-128-128V256c0-70.4 57.6-128 128-128h225l95 96h320c70.4 0 128 57.6 128 128v416c0 70.4-57.6 128-128 128z" fill="#409EFF" p-id="21178"></path>
			<path d="M64 384v384c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128V384H64z" fill="#92C8FF" p-id="21179"></path>
			<path d="M464 768H240c-26.4 0-48-21.6-48-48s21.6-48 48-48h224c26.4 0 48 21.6 48 48s-21.6 48-48 48z" fill="#479afc" p-id="21180"></path>
		</svg>
	</div>
</template>
<script setup name="FolderIcon2">
	let props = defineProps({
		size: {
			type: [Number,String],
			default: () => 24
		}
	})
</script>
<style scoped lang="less">
	.FolderIcon3,
	.svgIcon {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>
